import React from "/vendor/react";
import { SvgIcon } from "/vendor/@material-ui/core";
import Bg from "./Bg";

interface Props {
  color: string;
}

const Icon = React.memo(({ color, ...props }: Props) => {
  return (
    <SvgIcon viewBox="0 0 64 64" {...props}>
      <Bg color={color}>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(16.6 43.3)">
            <ellipse fill="#EFEFEF" cx="16.1" cy="26.4" rx="16.1" ry="26.4" />
            <path
              d="M24.4 11.6c3.6 0 3.4 5 3.4 3.2 0-.7 2-.5 2.3-1.2.3-.4-1.2-3.8-1.5-4.6-.3-.9-2.1-3.9-3.3-3.9-3.5 0-7.3 1.5-7.3 3.3 0 1.7 2.9 3.2 6.4 3.2z"
              fill="#414141"
            />
            <path
              d="M7.7 11.6c1.8 0 3.9-.8 3.9-2.6S8.8 5.1 7 5.1c-1.8 0-3.4 3.4-3.4 5.2v1.3c.3.8 1.2 1.3 2.1 1.3.6 0 1.4-1.3 2-1.3z"
              fill="#D99156"
            />
            <path
              d="M14 18.8c1.1 0 2.4-2 2-3.4-.2-1.2-2-2-2-2.5 0-1.3-.3-3.9-2.4-3.9a3.9 3.9 0 00-3.9 3.9c0 2 4.1 5.9 6.3 5.9z"
              fill="#D99156"
            />
            <path
              d="M26.1 15.4c.8 1.4 1.7 2 2.7 2 .8-.6 1.1-1.2 1-2-.3-1.3-1.5-1.4-2.2-2.5-.8-1.4-1.1-3.8-1.5-3.9-1.3-.3-3 2.5-3 3.9s1.9.5 3 2.5zM3.9 18c.7 0 1.2-1.2 1.2-2.6 0-1.4-.5-6.1-1.2-6.1-.5 0-1.8 3.2-2 5-.2 1 .7.6.7 1.1 0 1.4.5 2.6 1.3 2.6z"
              fill="#414141"
            />
          </g>
          <g transform="translate(7.6 6)">
            <ellipse fill="#EFEFEF" cx="24.3" cy="26.6" rx="19.2" ry="18.7" />
            <path
              d="M43.4 4.9c1.6.8 2 2.5 1.3 4.9-.6 2.4-2.4 5.6-5.3 9.4a1 1 0 01-1-.6c-.2-.4-.5-1.3-.7-2.6l-7.8-5.2 13.5-6z"
              fill="#D99156"
            />
            <path
              d="M5.5 5.3c-1.6.8-2 2.5-1.4 5 .7 2.4 2.5 5.6 5.4 9.4 1-1.5 1.9-2.5 2.7-3.2.8-.7 2.2-1.2 4.4-1.3a7.7 7.7 0 002.5-1.8c.3-.5.3-1.2 0-2.2l-13.6-6z"
              fill="#414141"
            />
          </g>
          <path
            d="M16.8 31.9c2.3 0 4.1-1.6 4.1-3.5 0-.6 2.3-.2 2.8-2.5 0-.5 2.2-.1 3.2-.4.9-.2 1.2-2.4.9-3-.1-.2-1.7-1-2-1.7-.4-.6.4-1.1 0-1.4-1.6-.8-3.5.1-3.6 0-.7-.4-4.2 3.1-5.2 3.1-.5 0-.7-1-1.3 0a34 34 0 01-1.5 2c-1 1.3-1.5 4.9-1.5 6 0 2 1.8 1.4 4.1 1.4z"
            fill="#414141"
          />
          <path
            d="M20.3 37.4c3.4 0 9.1-3 9.1-6.9 0-3.8-1.6-6-5-6s-6.2 2.2-6.2 6-1.3 7 2.1 7z"
            fill="#D99156"
          />
          <path
            d="M46.3 31.9c1 0 4-.3 4.8-1.4.2-.3-.2-1.6-.5-2.7l-.5-1.5c0-.9-1-2-2-2.6-.6-.3-1-.1-1.8-.1-1.9 0-3.4 4-3.4 5.5s1.5 2.8 3.4 2.8z"
            fill="#414141"
          />
          <path
            d="M37.4 22.2c0 .3-.3 2.5 0 3.3.3 1 1.1.7 1.6.8.3.1 1.7 1.1 2.6 1.4 2.5.7 5.8-.4 4-4.2-.2-.6 3.5-4.4 3.5-4.8 0-2-9.4-3.5-11.7-3.5-2.3 0-4.1 1.6-4.1 3.5 0 2 4 2.3 4 3.5z"
            fill="#D99156"
          />
          <g transform="translate(24.3 27.9)">
            <path fill="#414141" fillRule="nonzero" d="M7 11.8v4.3h2.6V12z" />
            <path
              d="M7 15c.3 1.6 1 2.7 2 3.5 1 .8 2.6.8 4.8.2l1.2-.4-.7-2.5-1.2.4c-1.5.4-2.4.4-2.6.2-.4-.3-.8-1-1-2l-.2-1.2-2.5.5L7 15z"
              fill="#414141"
              fillRule="nonzero"
            />
            <path
              d="M9 14.3c-.4 2-1.1 3.4-2.1 4.2-1.1.8-2.7.8-4.8.2l-1.3-.4.7-2.5 1.3.4c1.4.4 2.3.4 2.6.2.4-.3.8-1.2 1.2-2.7l.3-1.3 2.5.6-.3 1.3z"
              fill="#414141"
              fillRule="nonzero"
            />
            <path
              d="M8.3 13.2c-2.1-.9-3.3-1.5-3.7-1.9-.9-.9-.7-.9-.7-1.8 2-.3 3.4-.5 4.4-.5 1 0 2.4.2 4.4.5 0 1 .1 1-.8 1.8-.4.4-1.7 1-3.6 1.9z"
              fill="#F297A9"
            />
            <ellipse fill="#000" cx="14.6" cy="3.4" rx="2.1" ry="3.4" />
            <ellipse fill="#000" cx="2.1" cy="3.4" rx="2.1" ry="3.4" />
          </g>
          <path
            d="M15.4 15.7c-1.9-1.4-2.6-1.4-2.1 0 0 .3.3.8.6 1.5.2.4.5 1 .5 1.3.3.7 1 1.8 2.1 3.1l3.8-3.6-2.4-.8-2.5-1.5zM48 15.7c2-1.4 2.6-1.4 2.2 0l-.6 1.5-.6 1.3c-.3.7-1 1.8-2 3.1L43 18c.6-.1 1.9-.5 2.4-.8l2.5-1.5z"
            fill="#F297A9"
          />
        </g>
      </Bg>
    </SvgIcon>
  );
});
Icon.displayName = "Avatar.Cat";

export default Icon;
